export function hasManagerialRole(roles: string[]): boolean {
  return roles.includes("SuperUser")
      || roles.includes("Admin")
      || roles.includes("SeniorManager")
      || roles.includes("PartnerSeniorManager")
}
